import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass('absolute z-50 w-full')
}
const _hoisted_4 = {
  class: "mt-1 rounded-md bg-white shadow-lg",
  style: {"top":"calc(100% + 5px)"}
}
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = ["onClick"]

import {PropType, ref, watch} from "vue";
import {SchoolDto} from "@/areas/schools/dtos/schoolDto";
import {CampaignDto} from "@/areas/campaigns/dtos/campaignDto";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignSearch',
  props: {
  // List of objects to search
  campaign: {
    type: Object as PropType<CampaignDto | undefined>,
    default: undefined
  },
  // Custom label styling
  style: {
    type: String,
  },
  filteredCampaigns: {
    type: Array as PropType<CampaignDto[]>,
    default: [],
  },
  showSearchResults: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: "Search..."
  }
},
  emits: ['campaign-change', 'input'],
  setup(__props, { emit: __emit }) {


const props = __props

const emit = __emit

const searchTerm = ref(props.campaign?.name || '')
const filteredCampaigns = ref<CampaignDto[]>(props.filteredCampaigns)
const showSearchResults = ref(props.showSearchResults)
const placeholder = ref(props.placeholder)

watch(() => props.campaign, (newValue) => {
  searchTerm.value = newValue?.name || ''
}, {
  immediate: true
});

watch(() => props.filteredCampaigns, (newValue) => {
  filteredCampaigns.value = props.filteredCampaigns
}, {
  immediate: true
});

const showResults = () => {
  showSearchResults.value = true
}
const hideSearchResults = () => {
  setTimeout(() => {
    showSearchResults.value = false;
  }, 200); // adjust delay as necessary
}

const select = (campaign: CampaignDto) => {
  searchTerm.value = campaign.name
  filteredCampaigns.value = []
  
  emit('campaign-change', campaign)
}

const createCampaign = async () => {
  await router.push({
    name: 'AddCampaign'
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      onFocus: showResults,
      onBlur: hideSearchResults,
      type: "text",
      placeholder: placeholder.value,
      class: _normalizeClass([__props.style, "mt-2 border border-gray-300 rounded-md py-1.5 px-2 outline-none shadow-sm w-80 sm:w-full"]),
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('input', searchTerm.value))),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event))
    }, null, 42, _hoisted_2), [
      [_vModelText, searchTerm.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCampaigns.value, (campaign) => {
            return (_openBlock(), _createElementBlock("li", {
              key: campaign.guid,
              class: "text-dark-blue px-3 py-2 hover:bg-gray-100 cursor-pointer text-left",
              onClick: ($event: any) => (select(campaign))
            }, _toDisplayString(campaign.displayName) + ", " + _toDisplayString(campaign.school.name) + ", " + _toDisplayString(campaign.school.address.city) + ", " + _toDisplayString(campaign.school.address.province), 9, _hoisted_6))
          }), 128))
        ]),
        _withDirectives(_createElementVNode("ul", {
          onClick: createCampaign,
          class: "text-dark-blue px-3 py-2 hover:bg-gray-100 cursor-pointer text-left"
        }, _toDisplayString('Campaign not found, click to Create New Campaign'), 512), [
          [_vShow, searchTerm.value.length > 0 && filteredCampaigns.value.length === 0]
        ])
      ])
    ], 512), [
      [_vShow, showSearchResults.value]
    ])
  ]))
}
}

})